import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import ArticleReview from "@/pages/article/review/page";
import ArticleShipping from "@/pages/article/shipping/page";
import ArticleCoupon from "@/pages/article/coupon/page";
import ArticleFinds from "@/pages/article/finds/page";
import ArticleLegit from "@/pages/article/legit/page";
import ArticleAlternatives from "@/pages/article/alternatives/page";
import ArticleShoes from "@/pages/article/shoes/page";
import ArticleFashion from "@/pages/article/fashion/page";
import ArticleSaving from "@/pages/article/saving/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sugargoo-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/sugargoo-spreadsheet-review",
    element: <ArticleReview />,
  },
  {
    path: "/sugargoo-shipping-cost",
    element: <ArticleShipping />,
  },
  {
    path: "/sugargoo-coupon-guide",
    element: <ArticleCoupon />,
  },
  {
    path: "/best-sugargoo-finds",
    element: <ArticleFinds />,
  },
  {
    path: "/is-sugargoo-legit",
    element: <ArticleLegit />,
  },
  {
    path: "/sugargoo-alternatives",
    element: <ArticleAlternatives />,
  },
  {
    path: "/sugargoo-shoes-guide",
    element: <ArticleShoes />,
  },
  {
    path: "/sugargoo-fashion-guide",
    element: <ArticleFashion />,
  },
  {
    path: "/sugargoo-saving-tips",
    element: <ArticleSaving />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;